import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-pdf@9.2.1_@types+react@18.3.31_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-pdf/dist/esm/Page/AnnotationLayer.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-pdf@9.2.1_@types+react@18.3.31_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-pdf/dist/esm/Page/TextLayer.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.20_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.101.0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/auth.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/loader.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/query.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/router.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/store.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/providers/theme.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/tma.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/toaster.provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
